<i18n>
{
  "PL": {
    "loading error": "Błąd ładowania...",
    "retry": "Ponów"
  }
}
</i18n>
<template>
  <div
    :class="$style['wrapper']"
    class="fetching-error-box"
  >
    <ds-fetching-error-icon />
    <span :class="$style['text']">{{ $t('loading error') }}</span>
    <ds-button
      class="fetching-error-btn"
      @click="$emit('retry')"
    >
      {{ $t('retry') }}
    </ds-button>
  </div>
</template>

<script>
import FetchingErrorIcon from "../icons/ds-fetching-error-icon";
import DsButton from "./ds-button";

export default {
  name: "DsFetchingError",
  components: {
    "ds-fetching-error-icon": FetchingErrorIcon,
    "ds-button": DsButton
  }
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: -15px 0px;
  border-radius: 5px;
  height: 100%;
  > * {
    margin: 15px 0px;
  }
}
.text {
  font-size: $font-big-size;
  color: $light-gray-color;
  font-weight: 600;
  line-height: 24px;
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-fetching-error.vue